import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import Cookies from 'js-cookie';
import { Post } from 'Xhr/Xhr';
import { FileOrImageDetector } from 'utils/FileOrImageDetector';
import { env } from 'env';

export const SaveReceiption = async (
  data,
  setEnableLoading,
  navigate
) => {
  console.log('data---<>', data);

  setEnableLoading(true);
  const user = JSON.parse(Cookies.get('user'));

  if (data?.mablagh === 0) {
    SwalAlert(
      'warning',
      'مبلغ بایستی از صفر بیشتر باشد',
      false
    );
    setEnableLoading(false);
    return;
  }

  SwalAlert(
    'warning',
    'آیا از ثبت قرارداد اطمینان دارید؟',
    true,
    () => {
      Post(
        'POST',
        `${process.env.REACT_APP_API_URL_API_ADD_FISH_HAYE_PARDAKHT_LIST}`,
        true,
        {
          base64Content: data?.fileContent,
          DateMadrak: data?.fileDate,
          Description: data?.fileDescription,
          Id: 0,
          IdPatient: user?.IdPatient,
          idTestimontial: data?.idTestimontial,
          IdType: 7,
          ImageOrFile: FileOrImageDetector(
            data?.fileBase64
          ),
          mablagh: data?.mablagh,
          NameFile: data?.fileName,
          ShomarePaigiri: data?.ShomarePaigiri.toString(),
        }
      ).then((response) => {
        if (response.data.resCode === 1) {
          // GetReceptions(data?.idTestimontial, setReceptions);

          SwalAlert(
            'success',
            response.data.resMessage,
            false
          ).then(() => navigate(-1));
        } else
          SwalAlert(
            'error',
            response.data.resMessage,
            false
          );

        setEnableLoading(false);
      });
    }
  );
};
